import React from "react";
import TooltipDefault from "../tooltip-default/TooltipDefault";
import useDictionary from "../../../hooks/useDictionary";
import styled from "styled-components";
import { SquareButtonMarker } from "../styled-templates";

const BaseIconButton = ({
                            id = null,
                            onClick = (e) => {},
                            showMarker = false,
                            disabled = false,
                            displayTooltip = false,
                            tooltipContent = 'Tooltip',
                            tooltipSize = '',
                            children,
                            ...extra
}) => {
    let { t } = useDictionary();

    return (
        <TooltipDefault content={t(tooltipContent)} disabled={disabled} size={tooltipSize}>
            <BaseIconButtonWrap {...extra} id={id} onClick={onClick}>
                <BaseIconButtonBody disabled={disabled}>
                    <BaseIconButtonMarker show={showMarker}/>
                    {children}
                </BaseIconButtonBody>
            </BaseIconButtonWrap>
        </TooltipDefault>
    );
};

const BaseIconButtonWrap = styled.button`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    max-width: 44px;
    max-height: 44px;
    border: none;
    background-color: transparent;
    cursor: ${props => props.disabled ? 'default' : 'pointer'};
    outline: none;
    padding: 0;
    margin: 0;
    
    &:hover{
        & > div {
            box-shadow: var(--int-box-shadow-color) 0 2px 2px 1px;
            transform: translateY(-1px);
            background-color: var(--default-bg-color);
        }
    }

    &:active{
        & > div {
            box-shadow: var(--int-box-shadow-color) 0 1px 2px 0;
            transform: translateY(0);
            background-color: var(--default-bg-block);
        }
    }
`;

const BaseIconButtonBody = styled.div`
    position: relative;
    transition: all .2s ease;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    border-radius: 11px;
    
    border: ${props => props.theme.text.primary} .2rem solid;
    color: ${props => props.theme.text.primary};
    background-color: var(--default-bg-block);
    box-shadow: var(--int-box-shadow-color) 0 1px 1px 0;
`;

const BaseIconButtonMarker = styled.span`
    position: absolute;
    display: ${props => props.show ? 'block' : 'none'};
    width: .6rem;
    height: .6rem;
    border-radius: .6rem;
    border: var(--default-bg-block) 2px solid;
    background-color: var(--accent-color-primary-hovered);
    right: -.3rem;
    top: -.3rem;
`;

export default BaseIconButton;